window.AppointmentBooking ??= {};
window.AppointmentBooking.SlotPickerModal ??= {};
window.AppointmentBooking.SlotPickerModal.Models ??= {};

AppointmentBooking.SlotPickerModal.Models.AppointmentGridDate = class AppointmentGridDate extends Backbone.Model {
  defaults() {
    return { slots: [] };
  }
};
AppointmentBooking.SlotPickerModal.Models.AppointmentGridDate.prototype.idAttribute = "date";
